import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet, useLocation } from 'react-router';

import { RegisterClientLayout, RegistrationContextProvider } from '@zeta-commons';
import { LoadingScreen } from '@zeta-core';
import { RouterLinks } from '../../app-route-paths';
import { CompactErrorPage } from '../../layouts/compact-layout';

const PersonalDetailsRegistrationPage = lazy(() => import('../../pages/auth/registration/personal-details'));
const VerificationRegistrationPage = lazy(() => import('../../pages/auth/registration/verification'));
const PasswordSetUpRegistrationPage = lazy(() => import('../../pages/auth/registration/password-set-up'));
const RegistrationSuccessPage = lazy(() => import('../../pages/auth/registration/success'));

const OutletWrapper = () => {
  const location = useLocation();
  return <Outlet context={location.state} />;
};

const RegistrationRoutes = [
  {
    path: 'registration',
    element: (
      <ErrorBoundary FallbackComponent={CompactErrorPage}>
        <RegistrationContextProvider>
          <Outlet />
        </RegistrationContextProvider>
      </ErrorBoundary>
    ),
    children: [
      {
        path: 'success',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <RegistrationSuccessPage />
          </Suspense>
        ),
      },
      {
        path: '',
        children: [
          { element: <Navigate to={RouterLinks.registerPersonalDetails} replace />, index: true },
          {
            path: '',
            element: (
              <RegisterClientLayout>
                <Suspense fallback={<LoadingScreen />}>
                  <OutletWrapper />
                </Suspense>
              </RegisterClientLayout>
            ),
            children: [
              {
                path: 'your-details',
                element: <PersonalDetailsRegistrationPage />,
              },
              {
                path: 'verification',
                element: <VerificationRegistrationPage />,
              },
              {
                path: 'password-set-up',
                element: <PasswordSetUpRegistrationPage />,
              },
              {
                path: '',
                element: <Navigate to="your-details" replace />,
              },
            ],
          },
          {
            path: 'main',
            element: (
              <RegisterClientLayout>
                <Suspense fallback={<LoadingScreen />}>
                  <OutletWrapper />
                </Suspense>
              </RegisterClientLayout>
            ),
            children: [
              {
                path: 'personal-details',
                element: <PersonalDetailsRegistrationPage />,
              },
              {
                path: '',
                element: <Navigate to="personal-details" replace />,
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to={RouterLinks.registerPersonalDetails} replace />,
      },
    ],
  },
];

export default RegistrationRoutes;
